import React from 'react';
import proptypes from 'prop-types';
import { Button } from 'antd';
import './custom-button.scss';

const CustomButton = ({
  children,
  type,
  size,
  className,
  onClick,
  block,
  shape,
  disabled,
  fixedIcon,
  icon = null,
  ...props
}) => (
  <Button
    type={type}
    size={size}
    className={`ant-btn-custom ${fixedIcon ? 'fixed' : ''} ${className}`}
    block={block}
    shape={shape}
    disabled={disabled}
    onClick={onClick}
    {...props}
  >
    <span className="content">{children}</span>
    {icon && <img className="fixed-icon icon" src={icon} alt="icon" />}
  </Button>
);

CustomButton.propTypes = {
  children: proptypes.oneOfType([proptypes.object, proptypes.string]),
  type: proptypes.string,
  size: proptypes.string,
  className: proptypes.string,
  onClick: proptypes.func,
  block: proptypes.bool,
  shape: proptypes.string,
  disabled: proptypes.bool,
};
export default CustomButton;
